import Vue, { VueConstructor } from 'vue';
import RulePopupVue from '@/components/RulePopup.vue';
import { IRulePopupOptions } from '@/types';

interface IRulePopup extends Vue {
  showRule: (flag: boolean) => void
  setRule: (rule: string) => void
}

const RulePopupConstructor = Vue.extend(RulePopupVue);

const defaults = {
  value: true,
  rule: '',
};
let instance!: IRulePopup;

const RulePopup = (options: IRulePopupOptions = {} as IRulePopupOptions) => {
  options = Object.assign({}, defaults, options);
  if (instance) {
    if (options.rule) {
      instance.setRule(options.rule);
    }
    instance.showRule(options.value!);
    return;
  }
  const parent = document.body;
  instance = new RulePopupConstructor({
    el: document.createElement('div'),
    data: options,
  });
  instance.$el.setAttribute('id', 'rule-popup');
  parent.appendChild(instance.$el);
  return instance;
}

export default {
  install(Vue: VueConstructor, opts: IRulePopupOptions = {} as IRulePopupOptions) {
    Object.assign(defaults, opts);
    Vue.prototype.$rulePopup = RulePopup;
  },
  RulePopup,
};
